// extracted by mini-css-extract-plugin
export var bodyRow = "_f5-d";
export var cardColumns = "_f5-e";
export var ellipsesOverflow = "_f5-2";
export var flatBottomCorners = "_f5-3";
export var flatTopCorners = "_f5-4";
export var headerActionsDropdown = "_f5-f";
export var headerBottomRow = "_f5-c";
export var headerTopRow = "_f5-b";
export var orderDetailsWrapper = "_f5-0";
export var orderInfoContainer = "_f5-1";
export var productDetails = "_f5-9";
export var productImage = "_f5-5";
export var responsiveTable = "_f5-8";
export var shipmentContainer = "_f5-a";
export var tableBottomLeft = "_f5-6";
export var tableBottomRight = "_f5-7";
export var trackingLink = "_f5-g";